import { NoTaskSelected } from "@/features/worklist/components/NoTaskSelected";
import { createFileRoute } from "@tanstack/react-router";

function WorklistIndex() {
    return <NoTaskSelected />;
}

export const Route = createFileRoute("/_app/worklist/")({
    component: WorklistIndex,
});
